import Icon from 'veui/components/Icon'
import { IconCaretUp } from 'dls-icons-vue'

Icon.register('caret-up', IconCaretUp)
